<template>
    <div class="col-md-12" v-if="payment_corrections.length >= 1">
        <div class="ibox form">

            <div class="ibox-title ibox-grey">
                <h4>{{ __('other_sources_of_receivables_and_liabilities') }}</h4>
                <button-open-help-modal :help-name="helpName"/>
            </div>

            <div class="ibox-content">
                <div class="row">
                    <div class="col-md-12">
                        <table-pagination :meta="meta"
                                          @paginate:per-page="changePerPage"
                                          @paginate:page="goToPage">
                        </table-pagination>
                    </div>
                </div>
                <div class="scroll-table">
                    <div class="table-responsive text-nowrap">
                        <table class="table table-striped main-table other-operations" data-model="operations">
                            <thead>
                            <tr>
                                <th class="th-first">
                                    <input type="checkbox" ref="check_all" @click="handleSelectAll">
                                </th>
                                <th>{{ __('date_issued') }}</th>
                                <th>{{ __('source_type') }}</th>
                                <th>{{ __('card_name_or_description') }}</th>
                                <th class="text-right">{{ __('value') }}</th>
                                <th>{{ __('due_date') }}</th>
                                <th class="text-right">{{ __('balance') }}</th>
                                <th>{{ __('currency') }}</th>
                                <th class="text-right">{{ __('exchange_rate') }}</th>
                                <th class="text-right">{{ __('balance_in_default_currency') }}</th>
                                <th class="th-before th-last"></th>
                            </tr>
                            </thead>

                            <tbody class="other-source bt-0" v-for="(operation, index) in payment_corrections">
                            <tr class="row-show" :class="{ 'row-even': index%2 === 1 }">
                                <td class="td-padding"  @click="toggleDetails(index)">
                                    <input type="checkbox" :value="operation.id" @change="handleOperationSelect(operation)" :checked="ids.includes(operation.id)">
                                </td>
                                <td class="td-padding" @click="toggleDetails(index)">{{ operation.date }}</td>
                                <td class="td-padding" @click="toggleDetails(index)">{{ operation.payment_source_name }}</td>
                                <td class="td-padding wrap-text-inside-td" @click="toggleDetails(index)">{{ operation.description }}</td>
                                <td class="td-padding text-right" @click="toggleDetails(index)"></td>
                                <td class="td-padding" @click="toggleDetails(index)"></td>
                                <td class="td-padding text-right" @click="toggleDetails(index)"></td>
                                <td class="td-padding" @click="toggleDetails(index)"></td>
                                <td class="td-padding text-right" @click="toggleDetails(index)"></td>
                                <td class="td-padding text-right" @click="toggleDetails(index)"></td>
                                <td class="text-right table-icons">
                                    <a v-if="operation.has_access_delete" class="icon-delete" data-toggle="tooltip" data-placement="top" title="" data-original-title="Usuń" @click="destroyCorrection(operation)">
                                        <i class="fa fa-trash"></i>
                                    </a>
                                 </td>
                            </tr>

                            <tr class="other-source-details" v-for="allocation in operation.connection_list_title" v-show="detailsVisible === index">
                                <td class="left-border wrap-text-inside-td" colspan="10" v-html="allocation['title']">
                                </td>
                                <td class="text-right table-icons">
                                    <a v-if="getPermission('operation_preview')" :href="showUrl(allocation)"  data-toggle="tooltip" data-placement="top" :title="__('show')" :data-original-title="__('show')">
                                        <i class="fa fa-eye"></i></a>
                                    <a v-if="getPermission('editing_other_operations')" :href="editUrl(allocation)" data-toggle="tooltip" data-placement="top" :title="__('edit')" :data-original-title="__('edit')">
                                        <i class="fa fa-pen"></i></a>
                                </td>

                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <table-pagination :meta="meta"
                                          @paginate:per-page="changePerPage"
                                          @paginate:page="goToPage">
                        </table-pagination>
                    </div>
                </div>
            </div>
            <div class="ibox-content">
                <bulk-action
                    :disabled="contractorHistoryPaymentCorrectionDisabled"
                    v-if="getPermission('perm_view_export_contractor_history') && !contractorHistoryPaymentCorrectionDisabled"
                    :url="bulkUrl"
                    table="operations-other-sources"
                    :ids="bulkIds"
                    param="operation_id"
                    table_title="other_sources_of_receivables_and_liabilities"/>
                <div v-if="getPermission('perm_view_export_contractor_history') && contractorHistoryPaymentCorrectionDisabled" >
                    <div>
                        {{ __('with_selected') }}:
                        <button data-toggle="dropdown" class="btn btn-primary btn-sm dropdown-toggle" disabled="">
                            {{ __('export') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tooltips from '../../mixins/hasTooltips.js';
    import mutations from '../../vuex/contractor_history/mutation_types.js'
    import permissions from '../../services/Permissions.js'
    import ButtonOpenHelpModal from '../../components/help/ButtonOpenHelpModal.vue';
    import Vue from "vue";

    export default {
        name: 'payment-corrections-history',
        components: { ButtonOpenHelpModal },
        mixins: [tooltips],
        data: function () {
            return {
                detailsVisible: '',
                ids: [],
                helpName: 'ZRB-005'
            }
        },
        methods: {
            toggleDetails: function(index) {
                this.detailsVisible = (this.detailsVisible === index ? null : index);
            },
            handleOperationSelect: function(operation) {
                this.detailsVisible = '';
                if (event.target.checked) {
                   this.selectOperation(operation)
                } else {
                   this.removeOperation(operation);
                   this.removeSelectAll();
                };
            },
            removeSelectAll: function() {
                this.$refs['check_all'].checked  = false;
            },
            handleSelectAll: function() {
                if(event.target.checked) {
                    this.selectAll();
                } else if (!event.target.checked) {
                    this.clearSelected();
                }
            },
            clearSelected: function() {
                this.payment_corrections.forEach(document => {
                    this.removeOperation(document);
                })
            },
            selectAll: function() {
                this.payment_corrections.forEach(document => {
                    this.selectOperation(document);
                })
            },
            selectOperation: function(operation) {
                console.log(operation.id)
                this.ids.push(operation.id);
            },
            removeOperation: function(operation) {
                if(this.ids.indexOf(operation.id) >= 0) this.ids.splice(this.ids.indexOf(operation.id), 1);
            },
            handleResponseSuccess: function(response) {
                if(response.data.alert_type == 'success'){
                    this.$emit('change', {
                        message: response.data.message,
                        props: this.$props
                    });
                }
                else{
                    this.showAlertOneOperationIsLocked(response.data.message)
                }

            },
            handleResponseFail: function(error) {
                toastr['error'](this.__('failed_to_perform_action')).css('border', '0px');
            },
            destroyCorrection: function(operation) {
                const _this = this;
                swal({
                  title: $.i18n._('delete_element_?'),
                  text: $.i18n._('it_will_not_be_possible_to_retrieve_it_later_!'),
                  type: "warning",
                  showCancelButton: true,
                  confirmButtonColor: "#DD6B55",
                  confirmButtonText: $.i18n._('delete'),
                  cancelButtonText: $.i18n._('cancel'),
                  closeOnConfirm: true
                }, function () {
                  _this.axios.delete(operation.destroy_url)
                      .then(response => _this.handleResponseSuccess(response))
                      .catch(error => _this.handleResponseFail(error));
                });

            },
            showAlertOneOperationIsLocked: function (message){
                swal(
                    {
                        title: "",
                        text: message,
                        type: "warning",
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Ok",
                        closeOnConfirm: true
                    },
                );
            },
            goToPage: function(page) {
                this.$emit('paginate', {
                    per_page: this.meta.per_page,
                    page: page,
                    props: this.$props
                });
            },
            changePerPage: function(per_page) {
                this.$emit('paginate', {
                    per_page: per_page,
                    page: 1,
                    props: this.$props
                });
            },
            getOperationParentOrSelf: function(operation) {
                return this.$store.getters.getOperationParentOrSelf(operation)
            },
            getOperationRootOrSelf: function(operation) {
                return this.$store.getters.getOperationRootOrSelf(operation)
            },
            editUrl: function (allocation) {
                return allocation.is_department_transfer ? allocation.edit_url + '&return=' + location : allocation.edit_url + '&returnUrl=' + location
            },
            showUrl: function (allocation) {
                if(allocation.show_url.includes('records/payments'))
                {
                    return allocation.is_department_transfer ? allocation.show_url + '&return=' + location : allocation.show_url + '?returnUrl=' + location
                }
                return allocation.is_department_transfer ? allocation.show_url + '&return=' + location : allocation.show_url + '&returnUrl=' + location
            },
            getPermission: function(permission) {
                return permissions.getPermission(this.permission_access, permission);
            },
        },
        props: [
            'payment_corrections', 'contractor_id', 'index', 'meta', 'permission_access'
        ],
        computed: {
            location: function() { return location.pathname },
            bulkUrl: function() { return '/summaries/contractor-history/' + this.payment_corrections[0].contractor_id + '/bulk-action'},
            bulkIds: function() { return this.ids },
            contractorHistoryPaymentCorrectionDisabled: function (){
                const _this = this;
                let hasAccess = true;
                let checked = this.payment_corrections.filter(function (item){
                    return _this.ids.includes(item.id)
                })
                if(checked.length == 0){
                    return false;
                }
                checked.forEach(payment_corrections => {
                    if(!payment_corrections.has_access_export){
                        hasAccess = false;
                    }
                })
                if(hasAccess){
                    return false;
                }
                else{
                    return true;
                }
            }
        }
    }
</script>

<style>

</style>
